module.exports = __webpack_public_path__ + "img/step01-active.dd428f03.png";